import LeaderBoardCard from './components/LeaderboardCard';

export default function Leaderboard() {
  return (
    <>
      <section className="mb-[51px]">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="uppercase mb-[19px] text-brand-primary-light">
              <span className="text-brand-primary">Looty</span> Leaderboard
            </h2>

            <p className="text-[#D7CCE0] max-w-[799px] text-sm">
              Each action you take on the app earns you Looty Points, helping you climb the ranks.
              Keep collecting points and aim for the top spot for a chance at exclusive rewards
              coming soon.
            </p>
          </div>

          <div className="flex gap-6">
            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total Keys Earned</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">12,118</div>
            </div>

            <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total Rewards Opened</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">32,118</div>
            </div>

            <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">
                Total Raffle Tickets Purchased
              </div>

              <div className="text-lg font-semibold text-grayscale-100 text-end">43,223</div>
            </div>
          </div>
        </div>
      </section>

      <div className="border-t border-grayscale-700 mb-[51px]"></div>

      <section>
        <div className="grid mb-3 grid-cols-15">
          <div className="col-span-2 pl-5 text-sm text-grayscale-300">Place</div>
          <div className="col-span-11 pl-4 text-sm text-grayscale-300">User Wallet</div>
          <div className="col-span-2 pr-5 text-sm text-grayscale-300 text-end">Points</div>
        </div>

        <LeaderBoardCard place={1} wallet="34kklw...hjk223" points={134322} />
        <LeaderBoardCard place={2} wallet="34kklw...hjk223" points={16322} />
        <LeaderBoardCard place={3} wallet="34kklw...hjk223" points={15322} />
        <LeaderBoardCard place={4} wallet="34kklw...hjk223" points={14322} />
        <LeaderBoardCard place={5} wallet="34kklw...hjk223" points={13322} />
        <LeaderBoardCard place={6} wallet="34kklw...hjk223" points={12322} />
        <LeaderBoardCard place={7} wallet="34kklw...hjk223" points={11322} />
      </section>
    </>
  );
}
